import React, { useState, useEffect } from 'react'

// components
import NavDashboard from '../../components/NavDashboard'
import { numberFormat } from '../../helper';

// apollo-client
import { GET_DASHBOARD } from '../../apollo/dashboard/query';
import { useLazyQuery } from '@apollo/client';

// react-apexcharts
import { Spinner, Table } from 'react-bootstrap';

// react-bootrap
import ReactApexChart from 'react-apexcharts';

export default function ReportaAll() {
    const [dashboard, setDasBoard] = useState()

    //   useLazyQuerys
    const [LoadDashboard, { data: getdashboard, loading }] = useLazyQuery(
        GET_DASHBOARD,
        { fetchPolicy: "cache-and-network" }
    );

    // ============== > useEffect <============== 

    useEffect(() => {
        if (getdashboard) setDasBoard(getdashboard?.dashboard);
    }, [getdashboard]);

    useEffect(() => {
        fetchDashboard()
    }, [])


    // ============== > fuctions <============== 

    const fetchDashboard = async () => {
        let shopId = JSON.parse(localStorage.getItem('SHOP_DATA'))?.id
        await LoadDashboard({
            variables: {
                where: {
                    shop: shopId,
                },
            },
        });
    }

    let month = {

        series: [{
            name: '',
            data: dashboard?.months?.map((a) => a?.amount)
        }],
        options: {
            chart: {
                height: 350,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    borderRadius: 10,
                    dataLabels: {
                        position: 'top', // top, center, bottom
                    },
                }
            },

            xaxis: {
                categories: dashboard?.months?.map((m) => m?.name),
                position: 'top',
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                crosshairs: {
                    fill: {
                        type: 'solid',
                        color: '#D8E3F0'
                    }
                },
                tooltip: {
                    enabled: true,
                }
            },
        },

    };

    let weeks = {

        series: [{
            name: '',
            data: dashboard?.weeks?.map((w) => w?.amount)
        }],
        options: {
            chart: {
                height: 350,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    borderRadius: 10,
                    dataLabels: {
                        position: 'top', // top, center, bottom
                    },
                }
            },

            xaxis: {
                categories: dashboard?.weeks?.map((w) => w?.name),
                position: 'top',
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                crosshairs: {
                    fill: {
                        type: 'solid',
                        color: '#D8E3F0'
                    }
                },
                tooltip: {
                    enabled: true,
                }
            },
        },

    };

    let years = {

        series: [{
            name: '',
            data: dashboard?.years?.map((y) => y?.amount)
        }],
        options: {
            chart: {
                height: 350,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    borderRadius: 10,
                    dataLabels: {
                        position: 'top', // top, center, bottom
                    },
                }
            },

            xaxis: {
                categories: dashboard?.years?.map((y) => y?.name),
                position: 'top',
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                crosshairs: {
                    fill: {
                        type: 'solid',
                        color: '#D8E3F0'
                    }
                },
                tooltip: {
                    enabled: true,
                }
            },
        },

    };


    return (
        <NavDashboard title="ລາຍງານພາບລວມ">
            
            {(loading && !getdashboard) && <Spinner />}
            <div style={{ display: "flex", justifyContent: 'center' }}>
                <div className="col-md-4">
                    <div className="dbox dbox--color-1">
                        <div className="dbox__body">
                            <span className="dbox__count" style={{ fontSize: "25px" }}>{numberFormat(dashboard?.totalMoney ?? 0)} ₭</span>
                            <span className="dbox__title">ຍອດຂາຍທັງໝົດ</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className='row' style={{ paddingLeft: "50px", paddingRight: "50px" }}>
                <div className="col-md-4">
                    <div className="dbox dbox--color-1">
                        <div className="dbox__body">
                            <span className="dbox__count">{numberFormat(dashboard?.totalPrice ?? 0)} </span>
                            <span className="dbox__title">ຍອດຂາຍກີບ</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="dbox dbox--color-2">
                        <div className="dbox__body">
                            <span className="dbox__count">{numberFormat(dashboard?.sumPriceBaht ?? 0)}</span>
                            <span className="dbox__title">ຍອດຂາຍບາດ</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="dbox dbox--color-3">
                        <div className="dbox__body">
                            <span className="dbox__count">{numberFormat(dashboard?.sumPriceUsd ?? 0)}</span>
                            <span className="dbox__title">ຍອດຂາຍໂດລາ</span>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ paddingLeft: "50px", paddingRight: "50px" }}>
                <div style={{ fontSize: "20px", fontWeight: "bold" }}>ລາຍງານປະຈຳອາທິດ</div>
                <ReactApexChart options={weeks.options} series={weeks.series} type="bar" height={350} />
            </div>

            <div style={{ paddingLeft: "50px", paddingRight: "50px" }}>
                <div style={{ fontSize: "20px", fontWeight: "bold" }}>ລາຍງານປະຈຳເດືອນ</div>
                <ReactApexChart options={month.options} series={month.series} type="bar" height={350} />
            </div>

            <div style={{ paddingLeft: "50px", paddingRight: "50px" }}>
                <div style={{ fontSize: "20px", fontWeight: "bold" }}>ລາຍງານປະຈຳປີ</div>
                <ReactApexChart options={years.options} series={years.series} type="bar" height={350} />
            </div>


            <div style={{ paddingLeft: "50px", paddingRight: "50px" }}>
                <div style={{ fontSize: "20px", fontWeight: "bold" }}>ສິນຄ້າຂາຍດີ</div>
                <Table striped hover>
                    <thead style={{ background: "#1F3A60", color: "white", fontWeight: "400" }}>

                        <tr>
                            <th>ລຳດັບ</th>
                            <th>ຊື່ສິນຄ້າ</th>
                            <th>ຈຳນວນທີ່ຂາຍ</th>
                        </tr>

                    </thead>
                    <tbody>
                        {dashboard?.goodProduct?.map((e, index) => (
                            <tr>
                                <td>{index + 1}</td>
                                <td>{e?.name}</td>
                                <td>{e?.amount}</td>
                            </tr>
                        ))
                        }
                    </tbody>
                </Table>
            </div>

        </NavDashboard>
    )
}
